import { useState } from "react";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

// /----------------------------------
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { LogReportObj } from "utils/types/general.types";
import { logReportData } from "assets/data/logReport";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

const LogReport = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs(from));
    const [toDate, setToDate] = useState<Dayjs | null>(dayjs(now));

    // -------------------------- log report table
    // const [logReportData, setHashtagsArr] = useState(hashtags);

    const columns: GridColDef[] = [
        { field: "name", headerName: "Name", flex: 2, minWidth: 250 },
        { field: "count", headerName: "Count", flex: 1, minWidth: 75 }
    ];

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col">
                    <div className="w-full text-center">
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="Log Report"
                        />
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            Log Report
                        </h1>
                    </div>
                    <div className="flex flex-col md:flex-row justify-end items-center gap-3 py-5 px-10">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DateTimePicker"]}>
                                <DatePicker
                                    label="From Date"
                                    value={fromDate}
                                    onChange={(newValue) =>
                                        setFromDate(newValue)
                                    }
                                />
                            </DemoContainer>
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DateTimePicker"]}>
                                <DatePicker
                                    label="To Date"
                                    value={toDate}
                                    onChange={(newValue) => setToDate(newValue)}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10 pb-10">
                        {/* add table here */}
                        <DataGrid
                            rows={logReportData}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        page: 0,
                                        pageSize: 15
                                    }
                                }
                            }}
                            pageSizeOptions={[15, 30, 50, 100]}
                            getRowId={(row: LogReportObj) => row.id}
                            className="w-full"
                            // checkboxSelection
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LogReport;
